import { Injectable } from '@angular/core';
import { ICurrency, ILov, IObject } from '../../../../../type_definitions/datatypes';
import { IOrderableItem } from './bp-profiles-catalog-data.service';

@Injectable()
export class BPProfilesCatalogService {
  private _filters:IObject;
  private _catalogTypes:ILov[];
  private _currency:ICurrency;
  private _orderableItems:IOrderableItem[];
  private _highlightedId:number;

  public get orderableItems():IOrderableItem[] {
    return this._orderableItems;
  }

  public set orderableItems(orderableItems:IOrderableItem[]) {
    this._orderableItems = orderableItems;
  }

  public get filters():IObject {
    return this._filters;
  }

  public set filters(filters:IObject) {
    this._filters = filters;
  }

  public get catalogTypes():ILov[] {
    return this._catalogTypes;
  }

  public set catalogTypes(catalogTypes:ILov[]) {
    this._catalogTypes = catalogTypes;
  }

  public get currency():ICurrency {
    return this._currency;
  }

  public set currency(currency:ICurrency) {
    this._currency = currency;
  }

  public get highlightedId():number {
    return this._highlightedId;
  }

  public set highlightedId(highlightedId:number) {
    this._highlightedId = highlightedId;
  }

  public clear():void {
    this.filters = undefined;
    this.catalogTypes = undefined;
    this.currency = undefined;
    this.orderableItems = undefined;
    this.highlightedId = undefined;
  }
}